<template>
  <div class="goods-list" :class="{ ['goods-list-' + current]: true }">
    <div class="title">
      <p>商品名称</p>
      <template v-if="current == 4">
        <p>数量</p>
        <p>实付单价</p>
      </template>
      <template v-if="current == 6">
        <p>总课时</p>
        <p>退款中课时</p>
        <p>已退款课时</p>
      </template>
      <p v-if="detail.order_type!=8">实付</p>
      <p class="expiry" v-if="current == 2">
        <span>学习有效期</span>
        <TooltipEx class="tooltipex" contentClass="tooltip-help" :delay="0">
          <img class="help" src="@/assets/images/course/help@2x.png" />
          <template v-slot:content>退款课程无法继续学习</template>
        </TooltipEx>
      </p>
    </div>
    <ul>
      <li v-for="(item, index) in detail.items" :key="index">
        <p>
          <span
            v-if="
              item.shop_status == 6 ||
              item.shop_status == 5 ||
              item.shop_status == 4 ||
              item.shop_status == 3
            "
            :class="
              item.shop_status == 5
                ? 'is-done'
                : item.shop_status == 6
                ? 'red'
                : ''
            "
          >
            {{
              detail.pay_status==8
              ?"部分退款":
              item.shop_status == 3
                ? "已申请"
                : item.shop_status == 4
                ? "退款中"
                : item.shop_status == 5
                ? "已退款"
                : "退款失败"
            }}
          </span>
          {{ item.shop_name }}
        </p>
        <template v-if="current == 4">
          <p>{{ item.product_number }}</p>
          <p class="price">
            <Currency class="currency"></Currency>
            <span>{{ item.price | price }}</span>
          </p>
        </template>
        <template v-if="current == 6">
          <p>
            {{ item.product_number }}
          </p>
          <p>
            {{ item.refunding_num }}
          </p>
          <p>
            {{ item.refunded_num || 0 }}
          </p>
        </template>
        <p class="price" v-if="detail.order_type!=8">
          <Currency class="currency"></Currency>
          <span>{{ item.paid_price | price }}</span>
        </p>
        <p class="expiry" v-if="current == 2">
          <template
            v-if="
              (item.shop_status >= 2 &&
                item.shop_status <= 10 &&
                detail.group_id == 0) ||
              detail.order_status == 2 ||
              (detail.order_status == 3 && item.shop_status == 5)
            "
          >
            <template v-if="item.valid_end_time > 0">
              {{ item.valid_end_time | tsFormat("yyyy/MM/dd ") }}到期
              <template v-if="item.valid_type == 2">
                （截止日期：{{ item.valid_time | tsFormat("yyyy/MM/dd") }}）
              </template>
              <template v-else-if="item.valid_type == 3">
                （按有效天数：{{ item.valid_time }}天）
              </template>
            </template>
            <template v-else>长期有效</template>
            <div v-if="item.shop_status == 5" style="color: #999">
              退款课程无法学习
            </div>
          </template>
          <template v-else>--</template>
        </p>
      </li>
    </ul>
  </div>
</template>
<script>
import TooltipEx from "@/components/TooltipEx.vue";

export default {
  name: "MemberOrderGoods",
  components: { TooltipEx },
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    current: {},
  },
};
</script>
<style lang="scss" scoped>
.goods-list {
  border: 1px solid #e6e6e6;
  border-radius: 3px;

  .tooltipex {
    display: inline-block;
    position: static;
    box-shadow: none;
    padding: 0;
    line-height: 1;
    background-color: transparent;
  }

  .title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 42px;
    padding: 0 20px;
    border-bottom: 1px solid #e6e6e6;
    background-color: #f7f7f7;

    p {
      font-size: 14px;
      font-weight: 500;
      width: 100px;
    }

    p:first-child {
      flex: 1;
      width: 0;
    }

    p.expiry {
      width: 300px;

      span {
        vertical-align: middle;
      }
    }
  }

  ul {
    max-height: 295px;
    padding: 0 20px;
    margin: 0;
    border: none;
    overflow-y: auto;

    li {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 54px;
      border-bottom: 1px solid #e6e6e6;

      p {
        width: 100px;
        font-size: 14px;
        color: #666;
      }

      p.price {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }

      p:first-child {
        flex: 1;
        width: 0;
        font-size: 14px;
        color: #666;

        span {
          display: inline-block;
          height: 22px;
          margin-right: 8px;
          padding: 0 3px;
          background-color: #f6b10e;
          border-radius: 4px;
          text-align: center;
          font-size: 14px;
          color: #fff;
          line-height: 22px;
        }

        .is-done {
          background-color: #a6a6a6;
        }

        .red {
          background-color: $primary-color;
        }
      }

      p.expiry {
        width: 300px;
      }

      &:last-child {
        border-bottom: none;
      }
    }
  }
}
.goods-list-6 {
  p:nth-last-child(1) {
    text-align: right;
    justify-content: flex-end !important;
  }

  p:nth-child(2) {
    width: 50px;
    text-align: right;
    margin-right: 50px;
  }

  p:nth-child(3) {
    width: 70px;
    text-align: right;
    margin-right: 30px;
  }

  p:nth-child(4) {
    width: 70px;
    text-align: right;
  }
}
.help {
  width: 15px;
  height: 15px;
  vertical-align: middle;
  margin-left: 7px;
}
</style>
<style lang="scss">
.tooltip-help {
  font-size: 14px;
}
</style>
